import { cn } from "@tellescope/utils";
import type { TellescopeFormFieldBaseProps } from "../types";
import { Label, NumberInput } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { FieldDescription } from "../FieldDescription";

export interface HeightFieldProps extends TellescopeFormFieldBaseProps<"Height"> {}

export const HeightField = ({
  title,
  description,
  htmlDescription,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
  required,
  autoFocus,
}: HeightFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);

  return (
    <div className="space-y-1">
      {!!title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <div className={cn("flex gap-2", className)}>
        <NumberInput
          value={value?.feet === 0 ? undefined : value?.feet}
          onChange={(feet) => onChange({ feet: feet ?? 0, inches: value?.inches ?? 0 })}
          onBlur={onBlur}
          placeholder={t("Feet")}
          precisionOptions={{ maxDecimalDigitCount: 0 }}
          className={cn(showError && "border-destructive")}
          autoFocus={autoFocus}
        />
        <NumberInput
          value={value?.inches}
          onChange={(inches) => onChange({ feet: value?.feet ?? 0, inches: inches ?? 0 })}
          onBlur={() => {
            if (value?.inches && value.inches > 11) {
              const newFeet = Math.floor(value.inches / 12) + (value?.feet ?? 0);
              const newInches = value.inches % 12;
              onChange({
                feet: newFeet,
                inches: newInches,
              });
            }
            onBlur?.();
          }}
          placeholder={t("Inches")}
          precisionOptions={{ maxDecimalDigitCount: 0 }}
          className={cn(showError && "border-destructive")}
        />
      </div>
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
